import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getLandDocuments(companyId, query) {
	return dataTransferWrap(
		ModulesMap.LAND_DOCUMENTS,
		dtConfig[ModulesMap.LAND_DOCUMENTS].getLandDocuments,
		{
			urlParams: {
				companyId,
			},
			params: query,
		},

	)
}

function getLandDocument(companyId, landDocumentId) {
	return dataTransferWrap(
		ModulesMap.LAND_DOCUMENTS,
		dtConfig[ModulesMap.LAND_DOCUMENTS].getLandDocument,
		{
			urlParams: {
				companyId,
				landDocumentId,
			},
		}
	)
}

function createLandDocument(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.LAND_DOCUMENTS,
		dtConfig[ModulesMap.LAND_DOCUMENTS].createLandDocument,
		{
			urlParams: {
				companyId,
			},
			...payload,
		}
	)
}


function putLandDocument(companyId, landDocumentId, payload) {
	return dataTransferWrap(
		ModulesMap.LAND_DOCUMENTS,
		dtConfig[ModulesMap.LAND_DOCUMENTS].putLandDocument,
		{
			urlParams: {
				companyId,
				landDocumentId,
			},
			...payload,
		}
	)
}

function patchLandDocument(companyId, landDocumentId, payload) {
	return dataTransferWrap(
		ModulesMap.LAND_DOCUMENTS,
		dtConfig[ModulesMap.LAND_DOCUMENTS].patchLandDocument,
		{
			urlParams: {
				companyId,
				landDocumentId,
			},
			...payload,
		}
	)
}

function deleteLandDocument(companyId, landDocumentId) {
	return dataTransferWrap(
		ModulesMap.LAND_DOCUMENTS,
		dtConfig[ModulesMap.LAND_DOCUMENTS].deleteLandDocument,
		{
			urlParams: {
				companyId,
				landDocumentId,
			},
		}
	)
}

function getLandDocumentPreview(companyId, landDocumentId) {
	return dataTransferWrap(
		ModulesMap.LAND_DOCUMENTS,
		dtConfig[ModulesMap.LAND_DOCUMENTS].getLandDocumentPreview,
		{
			urlParams: {
				companyId,
				landDocumentId,
			},
		}
	)
}

function getLandDocumentPopup(companyId, landDocumentId) {
	return dataTransferWrap(
		ModulesMap.LAND_DOCUMENTS,
		dtConfig[ModulesMap.LAND_DOCUMENTS].getLandDocumentPopup,
		{
			urlParams: {
				companyId,
				landDocumentId,
			},
		}
	)
}

export default {
	getLandDocuments,
	getLandDocument,
	createLandDocument,
	putLandDocument,
	patchLandDocument,
	deleteLandDocument,
	getLandDocumentPreview,
	getLandDocumentPopup,
}

